<div
  [ngStyle]="getOuterStyles()"
  [class.error-wrapper]="form.invalid"
  class="widget-wrapper"
  style="min-height: 100%"
>
  <div class="form-wrapper">
    <form class="w-100" [formGroup]="form">
      <div>
        <finxone-input
          [type]="'text'"
          [name]="'cardName'"
          [label]="attri.widgetProperties.textContent || ''"
          formControlName="cardName"
          [value]="form.get('cardName')?.value"
          [showErrors]="true"
          [validationConfig]="validationConfig"
          [formControlInvalid]="form.controls['cardName'].dirty && form.controls['cardName'].touched"
        >
        </finxone-input>
      </div>
    </form>
  </div>
</div>
